import TrafficAwarenessPage from './TrafficAwarenessPage';
export default TrafficAwarenessPage;
